import { Component, OnInit } from '@angular/core';

import { CBMError, Maintenance } from 'app/models';
import { MaintenanceService, OAuthService } from 'app/services';

@Component({
  selector: 'app-login-keycloak',
  templateUrl: './login-keycloak.component.html',
  styleUrls: ['./login-keycloak.component.scss']
})
export class LoginKeycloakComponent implements OnInit {
  public pageTitle = 'NDW - CBM';
  public errorMessages: CBMError[] = [];
  public maintenance: Maintenance;

  constructor(private readonly maintenanceService: MaintenanceService, private readonly oauthService: OAuthService) {}

  ngOnInit() {
    this.pageTitle = `${this.pageTitle} - Inloggen.`;
    this.getMaintenance();
    this.oauthService.initPkceFlow();
  }

  private getMaintenance(): void {
    this.maintenanceService.getMaintenance().subscribe(
      response => {
        this.maintenance = response;
      },
      (errors: CBMError[]) => console.log(errors)
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/login-keycloak/login-keycloak.component.ts